import styledComponents from 'styled-components';

import React from 'react';
export default styledComponents.span`
  margin:0;
  margin-left: 4px;
  ${({ expand }) => expand && 'flex: 1;'}
  ${({ rightAlign }) => (rightAlign ? 'display: flex; flex-direction: row-reverse;' : '')}
  `;
